// extracted by mini-css-extract-plugin
export default {"time":"DateTime_time__mfl-A","date":"DateTime_date__baEfK"};